import { FloatingFormItem, Group, SaveButton } from '@/components/_common';
import {
  useCompanySettings,
  useCreateCompanySettings,
  useUpdateCompanySettings,
} from '@/core/domain/enterprise/Companies/Companies.hooks';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Checkbox, Col, Divider, Form, Row, Skeleton, Typography } from 'antd';
import { CompanySettingsFormValues } from '@/core/domain/enterprise/Companies/Companies.types';
import { useForm } from 'antd/lib/form/Form';
import { useWindowSize } from '@/hooks';

export default function SettingsCompanyPurchase() {
  const { width } = useWindowSize();
  const [form] = useForm<CompanySettingsFormValues>();

  const { companyId } = useRouteMatch<{ companyId: string }>().params;
  const { data, isLoading } = useCompanySettings(+companyId);
  const createMutation = useCreateCompanySettings(
    'A configuração de compra foi criada com sucesso',
  );
  const updateMutation = useUpdateCompanySettings(
    'A configuração de compra foi alterada com sucesso',
  );

  const loading = createMutation.isLoading || updateMutation.isLoading;

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  const handleSave = async () => {
    const values = await form.validateFields();

    if (!data) {
      createMutation.mutateAsync({
        companyId: Number(companyId),
        ...values,
      });
    } else {
      updateMutation.mutateAsync({
        ...data,
        ...values,
      });
    }
  };

  return (
    <>
      <Group position="between" align="center">
        <Typography.Title level={width < 576 ? 5 : 4}>Compras</Typography.Title>

        <SaveButton type="primary" onClick={handleSave} loading={loading}>
          Salvar
        </SaveButton>
      </Group>

      <Divider />

      <Form layout="horizontal" form={form}>
        <Skeleton active loading={isLoading}>
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <Row gutter={12}>
                <Col span={24}>
                  <Typography.Title level={4}>Importação</Typography.Title>
                </Col>

                <Col span={24}>
                  <FloatingFormItem
                    valuePropName="checked"
                    name="isOutputCfopBlockedInPurchaseImport"
                  >
                    <Checkbox>
                      Bloquear CFOP de saída na importação da compra
                    </Checkbox>
                  </FloatingFormItem>
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <Row gutter={12}>
                <Col span={24}>
                  <Typography.Title level={4}>Itens</Typography.Title>
                </Col>

                <Col span={24}>
                  <FloatingFormItem
                    valuePropName="checked"
                    name="allowInformSellPriceInPurchaseItem"
                  >
                    <Checkbox>
                      Permitir informar o preço de venda no item da compra
                    </Checkbox>
                  </FloatingFormItem>
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <Row gutter={12}>
                <Col span={24}>
                  <Typography.Title level={4}>Cancelamento</Typography.Title>
                </Col>

                <Col span={24}>
                  <FloatingFormItem
                    valuePropName="checked"
                    name="shouldProvideCancellationReasonInPurchase"
                  >
                    <Checkbox>
                      Adicionar motivo do cancelamento na compra
                    </Checkbox>
                  </FloatingFormItem>
                </Col>
              </Row>
            </Col>
          </Row>
        </Skeleton>
      </Form>
    </>
  );
}
